import { render, staticRenderFns } from "./CoalStock3DView.vue?vue&type=template&id=4b6c86af&scoped=true"
import script from "./CoalStock3DView.vue?vue&type=script&lang=js"
export * from "./CoalStock3DView.vue?vue&type=script&lang=js"
import style0 from "./CoalStock3DView.vue?vue&type=style&index=0&id=4b6c86af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6c86af",
  null
  
)

export default component.exports